var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-cascader',{attrs:{"options":_vm.options,"placeholder":"请选择地区","size":"small","props":{
    value: 'value',
    label: 'text',
    children: 'children',
  }},model:{value:(_vm.values),callback:function ($$v) {_vm.values=$$v},expression:"values"}})
}
var staticRenderFns = []

export { render, staticRenderFns }